import { Inject, Injectable } from '@angular/core'
import { PaymentsPayoutDateService } from '../../features/payments/services/payments-payout-date.service'
import { Store } from '@ngrx/store'

@Injectable({
    providedIn: 'root'
})
export class ProjectDependentDataService {

    constructor(@Inject(Store) private store: Store,
                @Inject(PaymentsPayoutDateService) private paymentsPayoutDateService: PaymentsPayoutDateService,
                ) {
    }

    resetProjectData(): void {
        this.paymentsPayoutDateService.resetDates()
    }
}
